var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNews = function SvgNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 38,
    viewBox: "0 0 46 38"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7 0h32v38H7z",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB467",
    d: "M0 10h46v19H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M6.98 24.734v-3.068l-.154-2.222 3.392 5.29h2.928V15h-2.98v3.068l.103 2.222L6.878 15H4v9.734h2.98zm15.313 0v-2.275h-4.296v-1.534h3.51V18.65h-3.51v-1.375h4.157V15H15.18v9.734h7.114zm6.078 0 1.012-5.66h.048l1.012 5.66h2.892L35.505 15h-2.796l-1.013 6.03-1.06-6.03h-2.41l-1.06 6.03h-.049L26.153 15H23.31l2.218 9.734h2.844zM39.725 25c2.784-.068 4.209-1.115 4.275-3.143 0-1.352-1.176-2.315-3.53-2.89-1.16-.304-1.74-.642-1.74-1.014-.032-.338.3-.524.995-.558.298.034.547.102.746.203.232.102.38.304.447.609h2.833c-.298-1.927-1.607-2.907-3.927-2.94-2.551.1-3.86 1.098-3.927 2.99 0 1.454 1.16 2.468 3.48 3.042 1.193.304 1.79.625 1.79.963-.034.44-.464.66-1.293.66-.364 0-.646-.068-.845-.203-.265-.136-.43-.389-.497-.76h-2.883c.265 1.926 1.624 2.94 4.076 3.041z"
  }))));
};
export default SvgNews;